<app-bread-crumb [items]="[{text:  'quotas',link:'/admin/quotes'},{text:pageTitle}]"
    [sectionTitle]="pageTitle"></app-bread-crumb>

<section class="content">

    <!-- inicio do formulário -->
    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <!-- inicio do box -->
        <ng-box [boxIcon]="'fa fa-dollar'" [boxTitle]="'Dados da Quota'" [showBoxFooter]="true">

            <!-- cabesalho do box -->
            <ng-container class="ng-box-header">
                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}">
                </ng-button>
            </ng-container>

            <!-- inicio do conteudo do box -->
            <ng-container class="ng-box-content">

                <div class="row">

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Clube(*)" errorMessage="Campo obrigatório">

                                <select formControlName="clubs_id" class="form-control">
                                    <option *ngFor="let club of clubs" [value]="club.id">{{ club.name }}</option>
                                </select>

                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Designação da Quota(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="quota_description" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Valor da Quota(*)"
                                errorMessage="- Campo obrigatório; - Somente números são aceites;">
                                <input type="text" formControlName="quota_value" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>

                <div class="row">
                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Dia do Pagamento(*)"
                                errorMessage="- Campo obrigatório; -Somente números são aceites;">
                                <input type="text" formControlName="payment_date" class="form-control">
                            </app-input>

                        </div>


                    </div>

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Periodicidade(*)" errorMessage="Campo obrigatório">
                                <select formControlName="periods_id" class="form-control">
                                    <option [value]="">Selecione o Periodo</option>
                                    <option value="1">Mensal</option>
                                    <option value="2">Trimestral</option>
                                    <option value="3">Semestral</option>
                                    <option value="4">Anual</option>
                                </select>
                            </app-input>

                        </div>

                    </div>

                </div>


            </ng-container>

            <!-- fim do conteudo do box -->

            <!-- inicio do rodapé -->
            <ng-container class="ng-box-footer">
                <div class="row">
                    <div class="col-xs-12">
                        <ng-button class="pull-right" [button]="{
                name:'salvar',
                color:'danger',
                faIconClass:'fa fa-save',
                type:'submit',
                loadingText:'SALVANDO',
                isLoading:isButtonLoading,
                isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>
                    </div>
                </div>
            </ng-container>
            <!-- fim do rodapé -->

        </ng-box>
        <!-- fim do box -->
    </form>
    <!-- fim do formulário -->
</section>